import _ from 'underscore';
import Utils from 'core-helpers/utils.js';
import Tracking from 'tracking/tracking-controller.ts';

var SelectLanguage = (function (root, doc, undefined) {

    'use strict';

    var clickHandler = function (e) {

        e.preventDefault();

        var targetValue = this.getAttribute('data-value');
        if(targetValue){
            Tracking.send('COURSE_SELECTED', {
                language_selected: targetValue,
                source_page: 'onboarding',
                course: 'none - web onboarding'
            });
        }

        setTimeout(function () {
            root.location.href = this.href;
        }.bind(this), 500);
    };

    var init = function () {
        var anchorFlags = Utils.getElementsByClass('js-flag');
        _.each(anchorFlags, function (flag) {
            flag.addEventListener('click', clickHandler);
        });
    };

    /**
     * Private vars
     */
    var filename = 'choose-your-language.js';

    init();

})(window, document);
